import { Divider, ToolbarButton } from "@fluentui/react-components";
import KeyboardArrowDownIcon from "~icons/material-symbols/keyboard-arrow-down";
import KeyboardArrowUpIcon from "~icons/material-symbols/keyboard-arrow-up";
import { Dispatch, memo, SetStateAction, useCallback, useMemo } from "react";
import { useSearchNavigationStyles } from "../styles/SearchNavigation.styles";

type SearchNavigationProps = {
  activeMark: number;
  filteredSearchLength: number;
  setActiveMark: Dispatch<SetStateAction<number>>;
};

export const SearchNavigation = memo(({ activeMark, filteredSearchLength, setActiveMark }: SearchNavigationProps) => {
  const styles = useSearchNavigationStyles();
  const navigateDown = useCallback(() => {
    setActiveMark((activeMark + 1) % filteredSearchLength);
  }, [activeMark, filteredSearchLength]);

  const navigateUp = useCallback(() => {
    setActiveMark((activeMark + filteredSearchLength - 1) % filteredSearchLength);
  }, [activeMark, filteredSearchLength]);
  const matchCount = useMemo(() => {
    return filteredSearchLength > 0 ? `${activeMark + 1}/${filteredSearchLength}` : "0/0";
  }, [activeMark, filteredSearchLength]);

  return (
    <div className={styles.searchInfoContainer}>
      <span className={styles.matchCount}>{matchCount}</span>

      <Divider vertical />

      <ToolbarButton
        disabled={filteredSearchLength === 0}
        icon={<KeyboardArrowUpIcon />}
        onClick={navigateUp}
        className={styles.smallButton}
      />

      <ToolbarButton
        disabled={filteredSearchLength === 0}
        icon={<KeyboardArrowDownIcon />}
        onClick={navigateDown}
        className={styles.smallButton}
      />
    </div>
  );
});
